<template>
  <div class="branding-block">
    <vx-card title="Branding" class="mb-6">
      <template slot="actions">
        <vs-button @click="openFormBranding()">New Branding</vs-button>
      </template>
      <form>
        <p class="mb-4">Setup the Branding you want to appear on your Sign-in Site</p>
        <div class="vx-row">
          <div class="vx-col w-full ">
            <tc-table
              :dataList="branding"
              @filter="filter"
              @selected="openFormBranding"
              :tbody="tbody"
              :settings="{
                externalFilters: {
                  show: false
                }
              }">
              <template slot="thead">
                <vs-th sort-key="category" width="80">Logo</vs-th>
                <vs-th sort-key="name">Brand name</vs-th>
                <vs-th>Actions</vs-th>
              </template>
            </tc-table>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BrandingTableBody from '@/components/tc-toble-body/Branding.vue';
export default {
  data: () => ({
    tbody: {
      component: BrandingTableBody
    }
  }),
  computed: {
    ...mapState('visitManagement', {
      branding: state => state.branding
    })
  },
  methods: {
    async filter (params) {
     var archivedParams= {
        ...params,
        archived:false
      }
      await this.$store.dispatch('visitManagement/fetchBranding', archivedParams);
    },
    openFormBranding (data) {
      this.$router.push(`/branding/${ data ? data.id : 'new' }`);
      // this.$root.$tcPopup.show({
      //   classes: 'vs-dialog--prevent-closing vs-dialog--fullscren',
      //   data: data || {},
      //   title: data ? 'Edit Branding' : 'New Branding',
      //   component: 'FormBranding',
      //   acceptText: 'Save'
      // })
    }
  }
}
</script>